import React from 'react';
import { Box, Typography } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';
import { neutral, primary } from '_lex/_foundations/phxColors';

export type LexTagVariant = 'default' | 'modified' | 'accreditation';

export type LexTagProps = {
  label: string;
  variant?: LexTagVariant;
  sx?: SxProps<Theme>;
};

type VariantStyle = {
  backgroundColor: string;
  border: string;
  color: string;
};

const variantStyles: Record<LexTagVariant, VariantStyle> = {
  default: {
    backgroundColor: 'transparent',
    border: `1px solid ${neutral[300]}`,
    color: neutral[500],
  },
  modified: {
    backgroundColor: neutral[100],
    border: 'none',
    color: neutral[600],
  },
  accreditation: {
    backgroundColor: primary[50],
    border: 'none',
    color: primary[600],
  },
};

function LexTag({ label, variant = 'default', sx }: LexTagProps) {
  return (
    <Box
      sx={[
        {
          display: 'inline-flex',
          alignItems: 'center',
          px: 2,
          pb: 0.5,
          pt: 1,
          borderRadius: '4px',
          ...variantStyles[variant],
        },
        ...(Array.isArray(sx) ? sx : [sx ?? {}]),
      ]}
    >
      <Typography
        variant="caption"
        sx={{
          fontWeight: 600,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          lineHeight: 1,
          color: 'inherit',
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}

export default LexTag;
